
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningRainShowersPolartwilight as ObiLightningRainShowersPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-rain-showers-polartwilight.js';
 
 
 

 
 export const ObiLightningRainShowersPolartwilight = createComponent({
   react: React,
   tagName: 'obi-lightning-rain-showers-polartwilight',
   elementClass: ObiLightningRainShowersPolartwilightElement,
   events: {
     
   }
  });
 
 